import React from "react";
import { Dropdown } from "primereact/dropdown";

export default function SelectMake({
  carMakers,
  setSelectedCarMaker,
  selectedCarMaker,
}) {
  const selectedCountryTemplate = (option, props) => {
    if (option) {
      return (
        <div className="prime-select">
          <img
            alt={option.name}
            src={`${process.env.REACT_APP_BTC_API_URL}/${option.flag}`}
            className={`mr-2 flag flag-${option.name}`}
            style={{ width: "18px" }}
          />
          <div>{option.name}</div>
        </div>
      );
    }

    return <span>{props.placeholder}</span>;
  };

  const countryOptionTemplate = (option) => {
    return (
      <div className="prime-select">
        <img
          alt={option.name}
          src={`${process.env.REACT_APP_BTC_API_URL}/${option.flag}`}
          className={`mr-2 flag flag-${option.name}`}
          style={{ width: "18px" }}
        />
        <div>{option.name}</div>
      </div>
    );
  };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Dropdown
        dataKey="_id"
        value={selectedCarMaker}
        onChange={(e) => {
          setSelectedCarMaker(e.value);
        }}
        options={carMakers}
        optionLabel="name"
        placeholder="Select a Make"
        valueTemplate={selectedCountryTemplate}
        itemTemplate={countryOptionTemplate}
        className="w-full md:w-14rem mx-width"
      />
    </div>
  );
}
